import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter as Router} from "react-router-dom";
import ErrorBoundary from "./components/common/ErrorBoundary";
import { installGlobalErrorHandlers } from "./utils/errorReporting";

// Report uncaught errors / unhandled rejections before anything renders.
installGlobalErrorHandlers();


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        {/* Last line of defence: a crash outside the routed pages shows a
            fallback card instead of a white screen. */}
        <ErrorBoundary variant="page">
            <Router>
                <App/>
            </Router>
        </ErrorBoundary>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
